import { Controller } from "@hotwired/stimulus"
import { put } from '@rails/request.js';

// Connects to data-controller="toggle-focus-mode"
export default class extends Controller {
  toggle(e){
    e.preventDefault();

    // Find Root Node
    const rootNode = document.querySelector('body[data-focus-mode]');
    
    // Update Focus Mode Value
    rootNode.dataset.focusMode = rootNode.dataset.focusMode === 'true' ? 'false' : 'true';

    // Persist Value
    this.persistValue();
  }

  async persistValue(){
    await put('/users/toggle_focus_mode.json')
  }
}
